module.exports = __webpack_public_path__ + "static/media/objCompleteLogo.51ed3c51.png";